import styled from 'styled-components'
import { Sticky, TStickyProps } from '../styles/mixins'
import { Container } from './Container'

export const StickyContainer = styled(Container)<TStickyProps>`
  ${(props: TStickyProps) => Sticky({ ...props })};
`
